import React from 'react';
import get from 'lodash/get';
import {FormattedMessage} from 'react-intl';
import {func, bool, oneOf, arrayOf, object, string} from 'prop-types';
import {Modal, Label, Button, Menu, Grid, Container} from 'semantic-ui-react';
import ResourceForm from 'components/forms/ResourceForm';
import BasicComponents from 'components/forms/Component Sets/BasicFormComponents';
import formConfig from './receiptItemFormConfig';
import {RetailerItemFormModes, RetailerItemPropType} from 'pages/Rewards/utils';
import {SitesByLanguage} from 'utils/DBUtils';
import {connect} from 'react-redux';


const isModalContainer = node => (
  ['modal', 'visible', 'active', 'primary-modal']
    .every(className => node.classList.contains(className))
);

const mapState = (state) => {
  let ngcApiId = undefined;
  if (state.rewards.ngcEndpoint) {
      ngcApiId = state.rewards.ngcEndpoint;
  }

  return {
    ngcApiId: ngcApiId
  }
}

const mapDispatch = (dispatch) => {
  return {
  }
}


const mergeProps = (stateProps, dispatchProps, ownProps) => {
  // pull in ngcApiId so ths component will validate
  if (stateProps.ngcApiId) {
    ownProps.retailerItem.ngcApiId = stateProps.ngcApiId;
  }
  return {
    ...ownProps
  }
}

class ReceiptItemModal extends React.Component {
  static propTypes = {
    isOpen: bool,
    isInFlight: bool,
    onClose: func.isRequired,
    lang: string.isRequired,
    mode: oneOf(Object.keys(RetailerItemFormModes)).isRequired,
    retailerItem: RetailerItemPropType.isRequired,
    deleteItem: func.isRequired,
    onSubmit: func.isRequired,
    onValueChanged: func.isRequired,
    onValidationError: func,
    apiError: string,
    errors: arrayOf(object)
  };

  static defaultProps = {
    errors: []
  };

  state = {
    confirmDeletion: false
  };

  get canSubmit() {
    const {fields} = formConfig[this.props.mode];
    const formIsComplete = fields.every(field => field.props.required && (typeof this.props.retailerItem[field.name] != "undefined"));

    // fields.every(field => {
    //   console.log("name: "+ field.name);
    //   console.log("requierd: "+ field.props.required);
    //   console.log("have data: "+  (typeof this.props.retailerItem[field.name] != "undefined"))
    // });

    const hasErrors = Boolean(this.props.apiError || this.props.errors.length);

    return formIsComplete && !hasErrors;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen && !this.props.isOpen) {
      // hide delete confirmation when modal is invoked subsequently.
      this.setState({confirmDeletion: false});

      const retailerItemId = get(nextProps.retailerItem, 'id', null);
      if (retailerItemId) {
        // try fetching images for this resource, if it already exists on the server.
        this.props.fetchItemImages(retailerItemId);
      }
    }

    if (nextProps.apiError !== this.props.apiError) {
      // if there's a new API error, scroll to the top of the modal content area so the user can see
      // the error message and re-evaluate their choices.
      this.modalNode.scrollTo(0, 0);
    }
  }

  handleRef = node => {
    if (node) {
      // traverse upward until we find the modal container responsible for scrolling.
      while (!isModalContainer(node.parentNode)) {
        node = node.parentNode;
      }

      this.modalNode = node;
    }
  };

  get deleteOptions() {
    return [
      {key: 'yes', onClick: this.props.deleteItem},
      {key: 'no', onClick: this.toggleDeleteConfirmation}
    ];
  }

  toggleDeleteConfirmation = () => {
    this.setState({confirmDeletion: !this.state.confirmDeletion});
  };

  render() {
    return this.props.mode && (
      <Modal
        size='small'
        dimmer='inverted'
        className='primary-modal retailer-item-modal'
        closeIcon={true}
        closeOnDimmerClick={false}
        open={this.props.isOpen}
        onClose={this.props.onClose}>
        <Modal.Header>
          <FormattedMessage
            id={`rewardsStore.modal.retailerItem.header.${this.props.mode.toLowerCase()}`}
            values={{site: SitesByLanguage[this.props.lang]}} />
        </Modal.Header>
        <Modal.Content
          className='retailer-item-modal-content'
          scrolling={true}>
          <div ref={this.handleRef} style={{display: 'none'}} />
          {this.props.apiError && (
            <Label basic className='db-error-label retailer-item-api-error'>
              <FormattedMessage id={`errors.${this.props.apiError}`} />
            </Label>
          )}
          <ResourceForm
            resource={this.props.retailerItem}
            config={formConfig[this.props.mode]}
            components={BasicComponents}
            errors={this.props.errors}
            onValueChanged={this.props.onValueChanged}
            onValidationError={this.props.onValidationError} />
        </Modal.Content>
        <Modal.Actions className='retailer-item-modal-actions'>
          <Grid>
            <Grid.Row columns={2} centered={true}>
              <Grid.Column textAlign='left' width={6}>
                {this.props.retailerItem.canDelete && (
                  <Button
                    negative={true}
                    className='retailer-item-delete-button'
                    onClick={this.toggleDeleteConfirmation}
                    disabled={this.state.confirmDeletion}>
                    <FormattedMessage id='rewardsStore.modal.retailerItem.button.delete' />
                  </Button>
                )}
              </Grid.Column>
              <Grid.Column textAlign='right' width={6}>
                <Menu.Item
                  className='retailer-item-cancel-menu-item'
                  onClick={this.props.onClose}
                  disabled={this.props.isInFlight}>
                  <FormattedMessage id='rewardsStore.modal.retailerItem.button.cancel' />
                </Menu.Item>
                <Button
                  primary={true}
                  className='retailer-item-submit-button'
                  onClick={this.props.onSubmit}
                  loading={this.props.isInFlight}
                  disabled={!this.canSubmit}>
                  <FormattedMessage id='rewardsStore.modal.retailerItem.button.submit' />
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {this.state.confirmDeletion && (
            <Container
              className='retailer-item-delete-confirm animResponse fadeInDown'
              textAlign='left'>
              <FormattedMessage id='rewardsStore.modal.retailerItem.delete.confirm' /> {this.deleteOptions.map(option => (
                <React.Fragment>
                  &nbsp;
                  <Menu.Item
                    key={option.key}
                    onClick={option.onClick}>
                    <FormattedMessage id={`rewardsStore.modal.retailerItem.delete.${option.key}`} />
                  </Menu.Item>
                  &nbsp;
                </React.Fragment>
              ))}
            </Container>
          )}
        </Modal.Actions>
      </Modal>
    );
  }
};

export default connect(mapState, mapDispatch, mergeProps)(ReceiptItemModal); 


// WEBPACK FOOTER //
// ./public/pages/Receipt/ReceiptItemModal.jsx